import React from 'react';
import './PageLoader.scss';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader"></div>
    </div>
  );
};

export default PageLoader;
